"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryImages = [{
  src: "https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/10/new-tiled-roof-southampton.jpg",
  alt: "New tiled roof completed in Southampton",
  caption: "New tiled roof",
  to: "/NewRoofsPage"
}, {
  src: "https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/10/grp-flat-roof-southampton.jpg",
  alt: "GRP fibreglass flat roof installed in Southampton",
  caption: "GRP flat roof",
  to: "/FlatRoofsPage"
}, {
  src: "https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/10/fascias-soffits-guttering-completed-southampton.jpg",
  alt: "Completed fascias, soffits and guttering in Southampton",
  caption: "Completed fascias, soffits and guttering",
  to: "/FasciasSoffitsPage"
}, {
  src: "https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/10/roof-restoration-dormers-southampton.jpg",
  alt: "Roof restoration around dormer windows in Southampton",
  caption: "Roof restoration with dormers",
  to: "/RoofingServicesPage"
}, {
  src: "https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/10/epdm-flat-roof-southampton.jpg",
  alt: "EPDM rubber flat roof installed in Southampton",
  caption: "EPDM flat roof",
  to: "/FlatRoofsPage"
}, {
  src: "https://qualityroofsandlandscapes.co.uk/wp-content/uploads/2026/10/fascia-soffit-gutter-install-southampton.jpg",
  alt: "Fascia, soffit and gutter installation in Southampton",
  caption: "Fascia, soffit and gutter installation",
  to: "/FasciasSoffitsPage"
}];
export default function SocialGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="252219" id="projectgallery" className="bg-background text-foreground py-16 sm:py-24 lg:py-[110px] overflow-hidden">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-12">
        {/* Eyebrow + Heading pattern matching WhyChooseFirststop */}
        <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
          <p className="text-xs md:text-sm font-bold uppercase tracking-widest text-primary mb-3">
            PORTFOLIO
          </p>
          <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-secondary-foreground mb-4">
            Our Recent Projects
          </h2>
          <p className="text-muted-foreground text-base md:text-lg max-w-2xl mx-auto font-default leading-relaxed">
            Explore our portfolio of high-quality roofing, flat roof, and guttering projects across Southampton, Hampshire &amp; surrounding areas.
          </p>
        </div>

        {/* 6-item photo grid with 14px radius, soft shadow and hover reveal */}
        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 transition-all duration-1000 ease-out motion-reduce:transition-none motion-reduce:transform-none ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {galleryImages.map((image, i) => <Link key={i} to={image.to} data-index={i} className="group block relative overflow-hidden bg-card rounded-[14px] border border-border shadow-[0_4px_20px_-2px_rgba(21,25,29,0.06)] hover:shadow-[0_12px_30px_-4px_rgba(21,25,29,0.12)] transition-all duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary">
              <AspectRatio ratio={4 / 3}>
                <img src={image.src} alt={image.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-700 ease-in-out group-hover:scale-105" />
                {/* Subtle dark gradient overlay from bottom */}
                <div aria-hidden="true" className="absolute inset-0 bg-gradient-to-t from-[#15191D]/80 via-[#15191D]/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300" />
                <div className="absolute inset-x-0 bottom-0 p-5 text-white">
                  <p className="text-xs font-bold uppercase tracking-wider text-primary mb-1">
                    Firststop Roofing
                  </p>
                  <p className="text-base font-bold leading-snug">
                    {image.caption}
                  </p>
                </div>
              </AspectRatio>
            </Link>)}
        </div>

        {/* View full gallery link */}
        <div className="mt-10 md:mt-12 text-center">
          <Link to="/GalleryPage" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-lg bg-card border border-border text-foreground hover:text-primary hover:border-primary font-semibold text-sm transition-colors shadow-sm">
            <span>View full gallery</span>
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>;
}